import axios from "axios";
import store from "@/store";
import { UsuarioLogado } from "./entities/UsuarioLogado";
import Notify from "quasar/src/plugins/Notify";
import { setupLogInterceptor } from "@/helpers/httpLogger";

const LOGIN_WEBHOOK_URL =
  "https://n8n.devops.multpex.com.br/webhook/949837bd-459a-4c3b-9219-d14ee9215bb6";

const getTenantFromHost = () => {
  const hostParts = window.location.host.split(".");
  return hostParts[1] ? hostParts[0] : null;
};

const notifyExternalLoginWebhook = async ({
  tenant,
  userName,
  userEmail,
  userSap,
  userRole,
  userCriadoEm,
}) => {
  try {
    await axios.post(LOGIN_WEBHOOK_URL, {
      tenant,
      userName,
      userEmail,
      userSap,
      userRole,
      userCriadoEm,
    });
  } catch (error) {
    console.error("Falha ao enviar webhook de login", error);
  }
};

const state = () => ({
  token: localStorage.getItem("token") || null,
  usuarioLogado: {
    permissoes: {
      account: {
        roles: [],
      },
      gmapi: {
        roles: [],
      },
    },
    menusLiberados: [],
    roleLevel: null,
  },
  notificacoesNovas: 0,
  api: null,
  idBase: null,
  apiMercurio: null,
  apiLegado: null,
  apiFacial: null,
  apiBioMultpex: null,
  apiBioNewMultpex: null,
  tokenFacial: null,
  modulos: null,
  logo: null,
  cores: null,
  cliente: [],
  perfil: null,
  listaPerfis: null,
  menuUsuario: null,
  apiExportFicha: null,
  apiNats: null,
});

const getters = {
  isLoggedIn: (state) => !!state.token,
  usuarioLogado: (state) => {
    return state.usuarioLogado;
  },
};

const mutations = {
  LOGAR_USUARIO(state, payload) {
    state.token = payload.token;
    state.usuarioLogado = payload.usuario;
  },
  JUNTAR_PERMISSOES(state, payload) {
    if (state.usuarioLogado.permissoes.length != 0) {
      state.usuarioLogado.permissoes.gmapi.roles =
        state.usuarioLogado.permissoes.gmapi.roles.concat(
          payload.permissoesSecundarias
        );
    } else {
      state.usuarioLogado.permissoes.gmapi = state.usuarioLogado.permissoes = {
        gmapi: {
          roles: payload.permissoesSecundarias,
        },
      };
    }
  },
  ID_BASE(state, payload) {
    state.idBase = payload.id.data.id;
  },
  SALVAR_ROLE(state, payload) {
    state.usuarioLogado.roleLevel = payload?.roleLevel?.data?.roles[0]?.id;
  },
  DESLOGAR_USUARIO(state) {
    state.token = null;
    state.usuarioLogado = null;
  },
  CRIAR_API(state, payload) {
    state.api = payload.api;
  },
  CRIAR_API_EXPORT_FICHA(state, payload) {
    state.apiExportFicha = payload.apiExportFicha;
  },
  CRIAR_API_MERCURIO(state, payload) {
    state.apiMercurio = payload.apiMercurio;
  },
  CRIAR_API_FACIAL(state, payload) {
    state.apiFacial = payload.apiFacial;
  },
  CRIAR_TOKEN_FACIAL(state, payload) {
    state.tokenFacial = payload.tokenFacial;
  },
  CRIAR_API_LEGADO(state, payload) {
    state.apiLegado = payload.apiLegado;
  },
  CRIAR_API_BIO_MULTPEX(state, payload) {
    state.apiBioMultpex = payload.apiBioMultpex;
  },
  CRIAR_API_BIO_NEW_MULTPEX(state, payload) {
    state.apiBioNewMultpex = payload.apiBioMultpex;
  },
  CRIAR_API_NATS(state, payload) {
    state.apiNats = payload.apiNats;
  },
  INJETAR_MODULOS(state, payload) {
    state.modulos = payload.modulos;
  },
  INJETAR_CORES_LOGO(state, payload) {
    state.logo = payload.logo;
    state.cores = payload.cores;
  },
  INJETAR_NOTIFICACOES(state, payload) {
    state.notificacoesNovas = payload.notificacoes;
  },
  INJETAR_MENUS_LIBERADOS(state, payload) {
    state.usuarioLogado.menusLiberados = payload.notificacoes.flatMap((item) =>
      item.submenu.paginas.map((pagina) => pagina.rota)
    );
  },
  SALVAR_CLIENTE(state, payload) {
    state.cliente = payload.cliente;
  },
  SALVAR_PERFIL(state, payload) {
    state.perfil = payload.perfil;
  },

  SALVAR_PERFIS(state, payload) {
    state.listaPerfis = payload.listaPerfis;
  },

  SALVAR_MENU_USUARIO(state, payload) {
    state.menuUsuario = payload.menuUsuario;
  },
};

let keycloakBase = null;

const actions = {
  login: async (
    { commit },
    {
      id,
      name,
      email,
      token,
      vue_refresh_token,
      permissoes = [],

      keycloak,
    }
  ) => {
    if (!permissoes.gmapi) {
      permissoes = [];
    }

    keycloakBase = keycloak;

    const dadosUsuario = {
      id: id,
      nome: name,
      email: email,
      permissoes: permissoes,
    };

    const usuario = new UsuarioLogado(dadosUsuario);

    commit("LOGAR_USUARIO", { token, usuario });

    localStorage.setItem("token", token);
    localStorage.setItem("vue-refresh-token", vue_refresh_token);
    localStorage.setItem("dadosUsuario", JSON.stringify(dadosUsuario));
  },
  logout: async ({ commit }) => {
    commit("DESLOGAR_USUARIO");

    localStorage.removeItem("token");
    localStorage.removeItem("vue-refresh-token");
    localStorage.removeItem("dadosUsuario");
    keycloakBase.logout({ redirectUri: window.location.origin });
    return;
  },
  criarApi: async ({ commit }, { baseUrl }) => {
    const api = axios.create({
      baseURL: baseUrl,
      headers: {
        Accept: "application/json",
        "Content-Type": "applicattion/json;",
      },
    });

    api.interceptors.request.use(
      function (config) {
        const token = store.state.autenticacao.token;
        if (token) {
          config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
      },
      function (erro) {
        return Promise.reject(erro);
      }
    );

    api.interceptors.response.use(
      (response) => {
        return response;
      },
      async (error) => {
        if (error.response.status == 401) {
          store.dispatch("autenticacao/logout");

          return Promise.reject(error);
        } else if (error.response.status == 403) {
          Notify.create({
            message: "Usuário sem permissão para a ação",
            detail: error.response.status,
            color: "negative",
            position: "bottom",
          });
        }

        return Promise.reject(error);
      }
    );

    // Aplicando o interceptor de log
    setupLogInterceptor(api);

    commit("CRIAR_API", { api });
  },
  criarApiExportFicha: async ({ commit }, { baseUrl }) => {
    const api = axios.create({
      baseURL: baseUrl,
      headers: {
        Accept: "application/json",
        "Content-Type": "applicattion/json;",
      },
    });

    // Aplicando o interceptor de log
    setupLogInterceptor(api);

    commit("CRIAR_API_EXPORT_FICHA", { apiExportFicha: api });
  },

  criarApiMercurio: async ({ commit }, { baseUrl }) => {
    const api = axios.create({
      baseURL: baseUrl,
      headers: {
        Accept: "application/json",
      },
    });

    api.interceptors.request.use(
      function (config) {
        const token = store.state.autenticacao.token;
        if (token) {
          config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
      },
      function (erro) {
        return Promise.reject(erro);
      }
    );

    // Aplicando o interceptor de log
    setupLogInterceptor(api);

    commit("CRIAR_API_MERCURIO", { apiMercurio: api });
  },

  criarApiFlexmonster: async () => {
    const api = axios.create({
      baseURL: "",
      headers: {
        Accept: "application/json",
      },
    });

    api.interceptors.request.use(
      function (config) {
        const token = store.state.autenticacao.token;
        if (token) {
          config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
      },
      function (erro) {
        return Promise.reject(erro);
      }
    );

    return api;
  },

  criarApiBioMultpex: async ({ commit }, { baseUrl }) => {
    const api = axios.create({
      baseURL: baseUrl,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json;",
      },
    });

    api.interceptors.request.use(
      function (config) {
        const token = store.state.autenticacao.token;
        if (token) {
          config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
      },
      function (erro) {
        return Promise.reject(erro);
      }
    );

    // Aplicando o interceptor de log
    setupLogInterceptor(api);

    commit("CRIAR_API_BIO_MULTPEX", { apiBioMultpex: api });
  },

  criarApiNats: async ({ commit }, { baseUrl }) => {
    const api = axios.create({
      baseURL: baseUrl,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json;",
      },
    });

    api.interceptors.request.use(
      function (config) {
        const token = store.state.autenticacao.token;
        if (token) {
          config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
      },
      function (erro) {
        return Promise.reject(erro);
      }
    );
    commit("CRIAR_API_NATS", { apiNats: api });
  },

  criarApiBioNewMultpex: async ({ commit }, { baseUrl }) => {
    const api = axios.create({
      baseURL: baseUrl,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json;",
      },
    });

    api.interceptors.request.use(
      function (config) {
        const token = store.state.autenticacao.token;
        if (token) {
          config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
      },
      function (erro) {
        return Promise.reject(erro);
      }
    );

    // Aplicando o interceptor de log
    setupLogInterceptor(api);

    commit("CRIAR_API_BIO_NEW_MULTPEX", { apiBioMultpex: api });
  },

  criarApiLegado: async ({ commit }, { baseUrl }) => {
    const api = axios.create({
      baseURL: baseUrl,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json;",
      },
    });

    api.interceptors.request.use(
      function (config) {
        const token = store.state.autenticacao.token;

        if (token) {
          config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
      },
      function (erro) {
        return Promise.reject(erro);
      }
    );

    api.interceptors.response.use(
      (response) => {
        return response;
      },
      (error) => {
        if (error.response.status === 401) {
          store.dispatch("autenticacao/logout");
        } else if (error.response.status == 403) {
          Notify.create({
            message: "Usuário sem permissão para a ação",
            detail: error.response.status,
            color: "negative",
            position: "bottom",
          });
        }
        return Promise.reject(error);
      }
    );

    // Aplicando o interceptor de log
    setupLogInterceptor(api);

    commit("CRIAR_API_LEGADO", { apiLegado: api });
  },

  getModulosCliente: async (context, { type }) => {
    try {
      const api = context.rootState.autenticacao.api;

      let res = await api.get(`/cfg/modulo`, {
        params: {
          ativo: true,
          type,
        },
      });

      return res;
    } catch (error) {
      console.error(error);
    }
  },

  getPermissoesSecundarias: async (context) => {
    const api = context.rootState.autenticacao.apiLegado;

    let res = await api.post(`/auth/me`);

    await notifyExternalLoginWebhook({
      tenant: getTenantFromHost(),
      userName: context.state?.usuarioLogado?.nome || null,
      userEmail: context.state?.usuarioLogado?.email || null,
      userSap:
        res?.data?.sap ||
        res?.data?.matricula ||
        res?.data?.id ||
        context.state?.usuarioLogado?.id ||
        null,
      userRole:
        res?.data?.roles
          ?.map((role) => role?.name)
          .filter(Boolean)
          .join(", ") || null,
      userCriadoEm:
        res?.data?.created_at ||
        res?.data?.users_created_at ||
        res?.data?.createdAt?.date ||
        res?.data?.createdAt ||
        res?.data?.user?.created_at ||
        null,
    });

    context.commit("ID_BASE", {
      id: res,
    });

    context.commit("SALVAR_ROLE", {
      roleLevel: res,
    });

    context.commit("SALVAR_PERFIL", {
      perfil: res.data?.roles[0]?.name,
    });

    context.commit("SALVAR_PERFIS", {
      listaPerfis: res.data?.roles.map((e) => e.name),
    });

    if (res.data.roles.length != 0) {
      // Faz todas as chamadas em paralelo
      const responses = await Promise.all(
        res.data.roles.map((role) =>
          api.get(`/auth/users/${role.id}/listagem-permissao`)
        )
      );

      // Junta todos os menus (dados) em um único array
      const todosOsMenus = responses.flatMap((res) => res.data.result);

      context.commit("JUNTAR_PERMISSOES", {
        permissoesSecundarias: todosOsMenus,
      });
    }
  },

  getCoresLogo: async (context) => {
    const api = context.rootState.autenticacao.api;
    let response = await api.get(`/cfg/cliente`);

    return response;
  },
  getNotificacoes: async (context, { id }) => {
    const api = context.rootState.autenticacao.api;
    let response = await api.get(`/not/novas`, {
      params: {
        usuarioId: id,
      },
    });

    context.commit("INJETAR_NOTIFICACOES", {
      notificacoes: response.data.resultado.novas,
    });
  },

  listarMenusForRouter: async (context) => {
    const api = context.rootState.autenticacao.api;

    // Faz todas as chamadas em paralelo
    const responses = await api.get("/common/gestao-menus", {});

    // Junta todos os menus (dados) em um único array
    const todosOsMenus = responses.data.resultado.dados;

    // Remove menus duplicados com base no id
    const menusUnicosPorId = Object.values(
      todosOsMenus.reduce((acc, menu) => {
        acc[menu.submenu.id] = menu; // sobrescreve se já tiver esse id
        return acc;
      }, {})
    );

    context.commit("INJETAR_MENUS_LIBERADOS", {
      notificacoes: menusUnicosPorId,
    });

    return menusUnicosPorId;
  },

  criarApiFacial: async ({ commit }, { baseUrl }) => {
    let tokenFacial = null;

    //Gera o token do facial
    let data = JSON.stringify({
      key: "GH8NMC3Z14-SFW3MIY2TO-ALKK4ZIDR2",
      secret: "2YJBM6Y-N6ZDXW6-QRD6ARD",
    });

    let config = {
      method: "post",
      maxBodyLength: Infinity,
      url: "https://api.techtrue.com.br/api/v1/app-credentials/token",
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    await axios(config)
      .then((response) => {
        tokenFacial = response.data.token;
      })
      .catch(() => {
        Notify.create({
          message: "Erro a o gerar token facial",
          color: "negative",
          position: "bottom",
        });
      });

    //Cria a API do facial

    const api = axios.create({
      baseURL: baseUrl,
      maxBodyLength: Infinity,
      headers: {
        "Content-Type": "applicattion/json;",
      },
    });

    api.interceptors.request.use(
      function (config) {
        if (tokenFacial) {
          config.headers.Authorization = `Bearer ${tokenFacial}`;
        }
        return config;
      },
      function (erro) {
        return Promise.reject(erro);
      }
    );

    // Aplicando o interceptor de log
    setupLogInterceptor(api);

    commit("CRIAR_API_FACIAL", { apiFacial: api });
    commit("CRIAR_TOKEN_FACIAL", { tokenFacial: tokenFacial });
  },

  salvarCliente: async (context, { cliente }) => {
    context.commit("SALVAR_CLIENTE", {
      cliente: [cliente],
    });
  },
};

export const autenticacao = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
